import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  "data-name": "Laag 1",
  viewBox: "0 0 45 45"
}
const _hoisted_2 = /*#__PURE__*/_createStaticVNode("<path d=\"M0 0h45v14H0z\" style=\"fill:currentColor;\"></path><path d=\"M0 14h18v36H0z\" style=\"fill:#e0e0e0;\"></path><rect width=\"12.5\" height=\"5\" x=\"2\" y=\"15\" rx=\"1\" ry=\"1\" style=\"fill:#b0b0b0;\"></rect><rect width=\"13.5\" height=\"9\" x=\"3.5\" y=\"22\" rx=\"1\" ry=\"1\" style=\"fill:currentColor;\"></rect><rect width=\"13.5\" height=\"7\" x=\"2\" y=\"33\" rx=\"1\" ry=\"1\" style=\"fill:#b0b0b0;\"></rect><path d=\"M0 0h45v45H0z\" style=\"fill:none;\"></path><path d=\"M.5.5h44v44H.5z\" style=\"stroke:#717070;fill:none;\"></path>", 7)
const _hoisted_9 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_9]))
}
export default { render: render }